import React, { useEffect, useState } from "react";
import { FaEdit, FaStar } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from '../../components/modals/ConfirmationModal';
import Toast from '../../components/Toast/Toast';
import { addTestimonialAPI, getTestimonialsAPI, deleteTestimonialAPI, updateTestimonialAPI } from '../../utils/api';
import Sidebar from "../Sidebar/Sidebar";
import AddTestimonialModal from "./components/AddTestimonialModal";
import { BASE_URL } from '../../utils/configConstants';
import "./Testimonials.css";

const getMediaUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return `${BASE_URL}${path.replace(/^\//, '')}`;
};

// const buildImageUrl = (path) => {
//     if (!path) return "";

//     if (typeof path === 'string') {
//         return path.startsWith('http') ? path : `${BASE_URL}${path.replace(/^\//, '')}`;
//     }

//     if (typeof path === 'object') {
//         const possiblePaths = [
//             path.profile_image,
//             path.image,
//             path.image_path,
//             path.img,
//             path.user_image,
//             path.url,
//             path.path,
//             path.src,
//             path.thumbnail,
//             path.profile_pic
//         ];

//         for (const imgPath of possiblePaths) {
//             if (imgPath && typeof imgPath === 'string') {
//                 return imgPath.startsWith('http') ? imgPath : `${BASE_URL}${imgPath.replace(/^\//, '')}`;
//             }
//         }
//     }

//     return "";
// };

const Testimonials = () => {
    const navigate = useNavigate();
    const [testimonials, setTestimonials] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [toast, setToast] = useState({ show: false, message: "", type: "" });
    const [showModal, setShowModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [saveLoading, setSaveLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const PAGE_LIMIT = 10;

    console.log("Testimonials component rendered", testimonials);
    const showToast = (message, type = "success") => {
        setToast({ show: true, message, type });
        setTimeout(() => setToast({ show: false, message: "", type: "" }), 3000);
    };

    console.log("testing 1");
    
    const fetchTestimonials = async () => {
        try {
            setLoading(true);
            setError(null);
        
            
            const response = await getTestimonialsAPI({
                page,
                limit: PAGE_LIMIT,
                search: searchTerm.trim().toLowerCase() || "",
            });
            console.log("response ===",response);
            console.log('Status:', response?.status);
            console.log('Data:', response?.data);

            if (response?.status === 200) {
                setTestimonials(response.data || []);
                setTotalPages(response?.pagination?.total_pages || 1);
            } else {
                setError(response?.message || 'Failed to fetch testimonials');
            }
        } catch (err) {
            console.error('Fetch error details:', err);
            setError('Failed to fetch testimonials. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTestimonials();
    }, [page, searchTerm]);

    const handleEdit = (item) => {
        setSelectedItem(item);
        setIsEditMode(true);
        setShowModal(true);
    };

    const handleAddNew = () => {
        setSelectedItem(null);
        setIsEditMode(false);
        setShowModal(true);
    };

    const handleSave = async (reqData) => {
        setSaveLoading(true);
        try {
            let response;


            if (isEditMode && selectedItem) {
                reqData.append('testimonial_id', selectedItem._id || selectedItem.id);
                console.log('=== UPDATE API called, testimonial_id:', selectedItem._id || selectedItem.id);
                response = await updateTestimonialAPI(reqData);
            } else {
                console.log('=== ADD API called ===');
                response = await addTestimonialAPI(reqData);
            }

            console.log("API Response ===", response);

            if (response?.status === 200) {
                await fetchTestimonials();
                setShowModal(false);
                showToast(`Testimonial ${isEditMode ? 'updated' : 'added'} successfully!`);
            } else {
                console.log('Save failed - message:', response?.message);
                showToast(response?.message || 'Failed to save testimonial', "error");
            }
        } catch (err) {
            console.error('Save error:', err);
            showToast('An error occurred. Please try again.', "error");
        } finally {
            setSaveLoading(false);
        }
    };

    const handleDeleteConfirm = async () => {
        try {
            const response = await deleteTestimonialAPI({ testimonial_id: itemToDelete._id || itemToDelete.id });
            if (response?.status === 200) {
                setShowDeleteModal(false);
                showToast("Testimonial deleted successfully!");
                await fetchTestimonials();
            } else {
                showToast(response?.message || 'Failed to delete testimonial', "error");
            }
        } catch (err) {
            console.error('Delete error:', err);
            showToast('An error occurred. Please try again.', "error");
        }
    };

    return (
        <div className="Testimonials-layout">
            <Sidebar />
            <Toast toast={toast} />
            <div className="Testimonials-main-content">
                <div className="Testimonials-header-row">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Search by user name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button className="insert-btn" onClick={handleAddNew}>
                        <span>Add Testimonial</span>
                    </button>
                </div>

                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading testimonials...</p>
                    </div>
                ) : error ? (
                    <div className="loading-container">
                        <p style={{ color: '#dc2626' }}>{error}</p>
                    </div>
                ) : testimonials.length === 0 ? (
                    <div className="empty-state">
                        <h3>No Testimonials Found</h3>
                        <p>Click "Add Testimonial" to create one.</p>
                    </div>
                ) : (
                    <div className="table-responsive">
                        <table className="Testimonials-table">
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>#</th>
                                    <th style={{ textAlign: "center" }}>User Name</th>
                                    <th style={{ textAlign: "center" }}>Image</th>
                                    <th style={{ textAlign: "center" }}>Rating</th>
                                    <th style={{ textAlign: "center" }}>Testimonial</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {testimonials.map((item, idx) => (
                                    <tr key={item._id || item.id || idx}>
                                        <td>{(page - 1) * PAGE_LIMIT + idx + 1}</td>
                                        <td>{item.user_name || item.name}</td>
                                        <td>
                                            <div className="testimonial-image-cell">
                                                {(item.profile_image ) ? (
                                                    <img 
                                                        src={getMediaUrl(item.profile_image)} 
                                                        className="testimonial-table-image"
                                                        alt="User"
                                                    />
                                                ) : (
                                                    <div className="category-no-image"><span>No Image</span></div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="rating-stars" style={{ justifyContent: 'center' }}>
                                                {[...Array(5)].map((_, i) => (
                                                    <FaStar key={i} style={{ color: i < (item.rating || 0) ? '#fbbf24' : '#e5e7eb' }} />
                                                ))}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="testimonial-text-cell">
                                                {item.testimonial || item.feedback}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="testimonial-action-btn-row">
                                                <button className="edit-btn" onClick={() => handleEdit(item)}>
                                                    <FaEdit />
                                                </button>
                                                <button className="delete-btn" onClick={() => { setItemToDelete(item); setShowDeleteModal(true); }}>
                                                    <MdDelete />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="table-footer">
                    <span>Showing {(page - 1) * PAGE_LIMIT + 1} to {Math.min(page * PAGE_LIMIT, (page-1) * PAGE_LIMIT + testimonials.length)} of {testimonials.length} entries</span>
                    <div className="pagination">
                        <button disabled={page === 1} onClick={() => setPage(page - 1)}>Previous</button>
                        <button className="active">{page}</button>
                        <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
                    </div>
                </div>

                <AddTestimonialModal
                    showModal={showModal}
                    isEditMode={isEditMode}
                    selectedItem={selectedItem}
                    saveLoading={saveLoading}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                />

                <ConfirmationModal
                    visible={showDeleteModal}
                    onConfirm={handleDeleteConfirm}
                    onCancel={() => setShowDeleteModal(false)}
                    title="Confirm Deletion"
                    message="Are you sure you want to delete this testimonial?"
                    confirmText="Delete"
                />
            </div>
        </div>
    );
};

export default Testimonials;
